import { Autocomplete, TextField } from "@mui/material";

export interface GenderProps {
  label: string;
  value: string;
}

const genders: GenderProps[] = [
  {
    label: "Herr",
    value: "f4285c6f-8b98-4ee8-bd61-7beb59f1df7b",
  },
  {
    label: "Frau",
    value: "96972cc0-a7e7-44b7-a618-7f43e75a8811",
  },
  {
    label: "Divers",
    value: "8c5bf3d1-7f5a-49d1-a66d-f6cce2fa33d7",
  },
];

interface GenderInputProps {
  disabled?: boolean;
  required?: boolean;
  gender: {
    label: string;
    value: string;
  } | null;
  setGender?: (option: { label: string; value: string } | null) => void;
  showValidation?: boolean;
  onBlur?: () => void;
}

const GenderInput = ({
  disabled,
  required,
  gender,
  setGender,
  showValidation = true,
  onBlur,
}: GenderInputProps): React.JSX.Element => {
  const changeGender = (
    _event: any,
    option: {
      label: string;
      value: string;
    } | null
  ): void => {
    if (setGender) {
      setGender(option);
    }
  };

  const isInvalid = gender === null;
  const showError = showValidation && isInvalid;

  return (
    <Autocomplete
      sx={{
        "& .MuiInputBase-root": {
          color: showError
            ? (theme) => theme.palette.error.main
            : isInvalid
              ? undefined
              : (theme) => theme.palette.success.main,
        },
      }}
      disabled={disabled}
      disablePortal
      value={gender}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={(event, option) => changeGender(event, option)}
      onBlur={onBlur}
      id="GenderInput"
      options={genders}
      renderInput={(params) => (
        <TextField
          focused={gender !== null}
          required={required}
          color="success"
          error={showError}
          helperText={showError ? "Bitte wähle eine Anrede" : ""}
          {...params}
          label="Anrede"
        />
      )}
    />
  );
};

export default GenderInput;
